export default class {
    constructor() {
        this.email = null;
        this.password = null;
    }
}



// WEBPACK FOOTER //
// ./src/models/LoginUser.js